/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/policies.actions'
import * as ActionTypes from '@src/redux/actionTypes/policies.action.types'
import { defaultState, PoliciesState } from './default.state'

export function reducer(
  state = defaultState,
  action: Actions.ActionTypes
): PoliciesState {
  switch (action.type) {
    case ActionTypes.GET_POLICIES_SUCCESS: {
      return {
        ...state,
        policyList: action.payload.policyList,
        isPending: false
      }
    }

    case ActionTypes.SET_SELECTED_POLICY: {
      return {
        ...state,
        selectedPolicy: action.payload.selectedPolicy,
        policyList: action.payload.selectedPolicy ? state.policyList : [],
        isPending: false
      }
    }

    case ActionTypes.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors
      }
    }

    case ActionTypes.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    default: {
      return state
    }
  }
}
